var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container not-found-page"},[_c('div',{staticClass:"not-found-page"},[_c('h1',[_vm._v("404")]),_c('img',{attrs:{"src":"https://console.offthecouch.io/img/pandas/search.png"}}),_c('p',{staticClass:"mt-4"},[_vm._v("The page you requested could not be found.")])])])
}]

export { render, staticRenderFns }